import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import _ from 'underscore';

import { Manifest } from 'services/action';

import { Page } from 'ui/components';
import {
  Action,
  SectionMap,
  SectionInfo,
  SectionLegs,
  SectionJobs,
  SectionSummary,
  SectionAdditional,
} from './component/detail';

const initialState = {
  data: null,
  privilege: null,
  legs: null,
  summary: {
    weight: 0,
    quantity: 0,
  },
};

const DetailScreen = ({ match }) => {
  const Dispatch = useDispatch();
  const History = useHistory();
  const Session = useSelector((state) => state.Auth?.session);
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Manifest.Show']
  );

  const [{ data, privilege }, setState] = React.useState(initialState);

  const $onLoad = async (id) => {
    const req = await Dispatch(Manifest.$show(id));

    if (req?.message === 'success') {
      if (req?.data?.status === 'cancelled') {
        History.replace('/manifest');
      }

      setState((prevState) => ({
        ...prevState,
        data: req?.data,
      }));
    } else {
      setState((prevState) => ({
        ...prevState,
        data: null,
      }));
    }
  };

  const $handleJobsChange = () => {
    $onLoad(match?.params?.id);
  };

  const $handleLegsChange = () => {
    $onLoad(match?.params?.id);
  };

  const $getPriviledge = async () => {
    const x = _.findWhere(Session?.privileges, {
      service: 'nvo.tms.manifest',
    });
    setState((prevState) => ({
      ...prevState,
      privilege: x,
    }));
  };

  React.useEffect(() => {
    $getPriviledge();
  }, [Session]);

  React.useEffect(() => {
    $onLoad(match?.params?.id);
  }, [match]);

  React.useEffect(() => {
    if (!data) return;

    let tw = _.reduce(
      data?.jobs,
      function (sum, item) {
        if (item?.delivery_order?.shipment) {
          return sum + item?.delivery_order?.shipment?.total_weight;
        }
        return sum;
      },
      0
    );

    let tq = _.reduce(
      data?.jobs,
      function (sum, item) {
        if (item?.delivery_order?.shipment) {
          return sum + item?.delivery_order?.shipment?.total_quantity;
        }
        return sum;
      },
      0
    );

    setState((prevState) => ({
      ...prevState,
      summary: {
        weight: tw,
        quantity: tq,
      },
    }));
  }, [data]);

  return (
    <Page className="">
      <Page.Header
        pretitle="Manifest"
        title={data?.code}
        status={data?.status}
        backTo="/manifest"
      >
        <Action
          data={data}
          onSubmit={() => $onLoad(match?.params?.id)}
          privilege={privilege?.action === 'manage' || !Session?.privileges}
        />
      </Page.Header>

      <Page.Body className="bg-light mt-3 mt-md-0">
        <SectionMap manifest={data} loading={StateLoading} />

        <div className="p3">
          <SectionSummary manifest={data} />

          <div className="row">
            <div className="col-md-4">
              <SectionInfo manifest={data} loading={StateLoading} />

              <SectionAdditional
                data={data}
                loading={StateLoading}
                onSubmit={() => $onLoad(match?.params?.id)}
              />
            </div>
            <div className="col-md-8">
              {data?.legs ? (
                <SectionLegs
                  manifest={data}
                  onLegChanges={$handleLegsChange}
                  loading={StateLoading}
                  privilege={
                    !Session?.privileges || privilege?.action === 'manage'
                  }
                />
              ): (
                <SectionJobs
                  manifest={data}
                  loading={StateLoading}
                  privilege={
                    !Session?.privileges || privilege?.action === 'manage'
                  }
                  onJobsChange={$handleJobsChange}
                />
              )}
            </div>
          </div>
        </div>
      </Page.Body>
    </Page>
  );
};

export default DetailScreen;
